import Vue from 'vue';
import { mapState } from 'vuex';
export default Vue.extend({
    computed: {
        ...mapState('productModule', ['currentProduct', 'currentVariant']),
        product() {
            return this.currentProduct;
        },
        variantContent() {
            return (this.currentVariant?.content ?? {});
        },
        productContent() {
            return (this.product?.content ?? {});
        },
        // ---- HIGHLIGHTS (variant first, then product) ----
        highlights() {
            const variantHighlights = this.variantContent.highlights ?? null;
            const productHighlights = this.productContent.highlights ?? null;
            const pick = variantHighlights ?? productHighlights;
            if (!pick)
                return null;
            const isLocalized = typeof pick === 'object' &&
                pick !== null &&
                Object.prototype.hasOwnProperty.call(pick, 'en');
            const value = isLocalized ? pick.en : pick;
            if (value == null)
                return null;
            if (Array.isArray(value)) {
                const cleaned = value.map((x) => String(x).trim()).filter(Boolean);
                return cleaned.length ? cleaned : null;
            }
            if (typeof value === 'string') {
                const s = value.trim();
                return s ? s : null;
            }
            return null;
        },
        hasHighlights() {
            if (!this.highlights)
                return false;
            if (Array.isArray(this.highlights))
                return this.highlights.length > 0;
            return this.hasText(this.highlights);
        },
    },
    methods: {
        hasText(val) {
            return typeof val === 'string' && val.trim().length > 0;
        },
    },
});
